import { TimePeriodTypeEnum } from '@shared/api/types';

export const filteredTimePeriodEnum = Object.keys(TimePeriodTypeEnum).filter(
  (key) => key !== TimePeriodTypeEnum['quarter']
);
